export default "__VITE_ASSET__BfeYnOnf__"